"use client";

import React from "react";
import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const locations = [{
  name: "מרכז העיר חדרה",
  description: "מענה סיעודי מהיר לדיירי מרכז העיר הוותיקים והחדשים כאחד.",
  href: "/NursingCaregiverHodHasharonWithinHoursPage",
  icon: MapPin
}, {
  name: "שכונת ניסן",
  description: "שירותי השגחה וליווי מקצועיים למשפחות בשכונת ניסן והסביבה.",
  href: "/NursingCaregiverHodHasharonWithinHoursPage",
  icon: MapPin
}, {
  name: "גבעת אולגה",
  description: "טיפול סיעודי מסור בקרבת קו החוף, כולל ליווי לבדיקות רפואיות.",
  href: "/NursingCaregiverHodHasharonWithinHoursPage",
  icon: MapPin
}, {
  name: "בית חולים העמק",
  description: "ליווי צמוד למאושפזים בבתי החולים הסמוכים ובמרכזים הרפואיים.",
  href: "/NursingCaregiverHodHasharonWithinHoursPage",
  icon: MapPin
}];
export default function NeighborhoodServiceAreas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="257394" id="מיקומים-וביתנות-בחדרה" className="py-16 md:py-24 bg-background text-foreground">
      <div className="page-container">
        <div ref={ref} className={cn("grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-700 opacity-0 translate-y-8", isVisible && "opacity-100 translate-y-0")}>
          {/* Content Column */}
          <div className="max-w-xl">
            <span className="text-primary font-semibold text-sm tracking-wider uppercase mb-3 block font-default">
              אזורי שירות בחדרה והסביבה
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 font-default leading-tight">
              מהמרכז ההיסטורי ועד לשכונות החדשות ביותר
            </h2>
            <p className="text-muted-foreground text-lg mb-8 leading-relaxed font-default">
              חדרה היא עיר של ניגודים וצמיחה — ממשפחות צעירות בשכונות החדשות ועד לתושבים ותיקים במרכז העיר ההיסטורי. אנו מכירים כל פינה בעיר ומעניקים שירות סיעודי מקצועי ומהיר לכלל התושבים, כולל ליווי למרכזים רפואיים סמוכים כמו בית החולים העמק, תוך הקפדה על יחס אישי וזמינות מיידית בכל שעה.
            </p>
            <Link to="/ServicesCitiesArticlesPage" className="inline-flex items-center gap-2 text-primary font-medium hover:text-primary/80 transition-colors group font-default">
              לצפייה בכל אזורי השירות
              <ArrowRight className="w-4 h-4 group-hover:-translate-x-1 transition-transform rotate-180" />
            </Link>
          </div>

          {/* Locations Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {locations.map((location, i) => <Link key={location.name} to={location.href} data-index={i} className="group block bg-card border border-border/60 rounded-lg p-6 shadow-md hover:shadow-lg hover:border-primary/30 transition-all duration-300">
                <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center text-primary mb-4 group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <location.icon className="w-5 h-5" />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2 font-default group-hover:text-primary transition-colors">
                  {location.name}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed font-default">
                  {location.description}
                </p>
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}